export default __webpack_public_path__ + "static/media/small-back-arrow.0fe0d0d7.svg";